<kt-portlet> 
    <kt-portlet-body>
        <kt-candidates-list></kt-candidates-list>
    </kt-portlet-body>
</kt-portlet>
